import script from "./MoreVertical.vue?vue&type=script&setup=true&lang=js"
export * from "./MoreVertical.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__